import {useQuery} from '@apollo/react-hooks';

import {makeDataDangerous, safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {ThreadType} from 'nutshell-graphql-types';
import type {GetInboundFacebookRules as GetInboundFacebookRulesQuery} from 'nutshell-graphql-types';

import GET_INBOUND_FACEBOOK_RULES from '../queries/get-inbound-facebook-rules.graphql';

export const useGetInboundFacebookRules = (threadType: ThreadType) => {
    const {data, error, loading, refetch} = useQuery<
        GetInboundFacebookRulesQuery,
        Record<any, any>
    >(GET_INBOUND_FACEBOOK_RULES, {
        variables: {
            threadType,
        },
    });

    const {inboundFacebookRules} = makeDataDangerous(data);

    return {
        inboundFacebookRules,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading: loading,
        refetch,
    };
};
